import axios from "axios";
import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'

function LabReportIpAll(props) {
      const {appt_id} = useParams();
      const [viewlabdata,setViewLabData] = useState([]);
      const [labtestData,setLabTestData] = useState([]);
      const [fetchedResults, setFetchedResults] = useState([]);
      const [isLoading, setIsLoading] = useState(true);
      const [labDataArray, setLabDataArray] = useState([]);

useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(baseUrl + 'ip-lab-report-all/' + appt_id + '/');
        setLabTestData(response.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [appt_id]);

  useEffect(() => {
    if (labtestData.length > 0) {
      fetchLabData();
    }
  }, [labtestData]);


async function fetchLabData() {
  const fetchedData = [];
  const allFetchedResults = [];

  for (const test of labtestData) {
    const ltestIds = test.ltest_id.split(',').map(item => item.trim());
    const results = test.results.split(',').map(item => item.trim());

    for (const ltestId of ltestIds) {
      try {
        const response = await axios.get(baseUrl + 'lab-test-view/' + ltestId + '/');
        fetchedData.push(response.data);

      } catch (error) {
        console.log(error);
      }
    }
    allFetchedResults.push(...results);
  }

   let flattendArray = fetchedData.flat()
  setViewLabData(flattendArray);
  setFetchedResults(allFetchedResults);
}
  if (isLoading) {
    return <div>Loading...</div>;
  }

const updatedLabbillData = viewlabdata.map((testsArray, testIndex) =>{
    let results = fetchedResults[testIndex];
    return (
      <tr key={`${testIndex + 1}`}>
        <td>{testsArray?.test}</td>
        <td>{results}</td>
        <td>{testsArray?.units}</td>
        <td>{testsArray?.ranges}</td>
      </tr>
    );
}

);
  return (
    <section>
      <div id="invoice-print">
          <div>
            <table className="erp-table-modern">
              <tr >
               <th className="mx-0 ps-5" rowSpan="10">
                    Name : {labtestData[0].pat.patient}
                       <br></br>
                    PID : {labtestData[0].pat.pat_id}<br></br>
                    Consultant : Dr.{labtestData[0].cons.consultant}
               </th>
               </tr>
               <tr >
               <th>
                    Gender : {labtestData[0].pat.gender}
                       <br></br>
                    Age : {labtestData[0].pat.age}
                          <br></br>
                    Sample Date : {labtestData[0].sample_date}
               </th>
               </tr>
            </table>
          </div>
          <div>
            <table className="erp-table-modern">
              <thead>
                <tr style={{backgroundColor: '#1bc5ce', color:'white'}}>
                   <th align="left">Test</th>
                   <th align="left">Result</th>
                   <th align="left">Units</th>
                   <th align="left">Ranges</th>
                </tr>
              </thead>
              <tbody>
               {updatedLabbillData}
            </tbody>
            </table>
            </div>
          </div>
          <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          <button style={{ padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff' }}>
           Print
          </button>
        </div>
    </section>
  );
  }
export default LabReportIpAll;